<section>
  <slot/>
</section>

<style lang="scss">
  section {
    margin: 0 $view-content-edge-spacing $view-sections-separation $view-content-edge-spacing;
  }
</style>